/* eslint-disable import/prefer-default-export */

import * as types from './home.types';

export const goHome = () => ({
  type: types.GO_HOME,
  payload: {},
});

/* eslint-enable import/prefer-default-export */



// WEBPACK FOOTER //
// ./src/store/actions/home.js